import React, { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { url } from 'helpers';
import { useAuth, useLang } from 'hooks';
import { PageLayout } from 'layouts';
import { ProfileStatus } from 'types/models';

import InfoRequiredView from './InfoRequiredView';
import StatusView from './StatusView';

const ProfileIncompletePage = () => {
  const auth = useAuth();
  const lang = useLang();

  const components: Record<ProfileStatus, ReactNode> = {
    [ProfileStatus.APPROVED]: null,
    [ProfileStatus.PERSONAL_INFO_REQUIRED]: <InfoRequiredView />,
    [ProfileStatus.REJECTED]: (
      <StatusView
        type="error"
        title={lang.get('profile.rejected.heading')}
        caption={lang.get('profile.rejected.caption')}
      />
    ),
    [ProfileStatus.SUSPENDED]: null,
    [ProfileStatus.TERMINATED]: (
      <StatusView
        type="error"
        title={lang.get('profile.terminated.heading')}
        caption={lang.get('profile.terminated.caption')}
      />
    ),
    [ProfileStatus.WAITING_FOR_APPROVAL]: (
      <StatusView
        type="success"
        title={lang.get('profile.waitingApproval.heading')}
        caption={lang.get('profile.waitingApproval.caption')}
      />
    ),
  };

  if (!auth.status || !components[auth.status]) {
    return <Navigate to={url.toDashboard()} />;
  }

  return (
    <PageLayout title={lang.get('profile.incompleteTitle')}>
      {components[auth.status]}
    </PageLayout>
  );
};

export default ProfileIncompletePage;
